exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.line-container[data-v-0553077e]{position:absolute;top:0;left:0;min-height:100%;width:100%;margin:0;padding-top:15px;z-index:10}div.line-container .line-bar[data-v-0553077e]{position:absolute}div.line-container .line-content[data-v-0553077e]{visibility:hidden}div.line-container ul[data-v-0553077e]{height:100%;padding:0;margin-top:0}div.line-container ul li[data-v-0553077e]{list-style:none;position:relative}div.line-container ul li .line-number[data-v-0553077e]{position:absolute;font-size:14px;width:35px;padding:0 5px;line-height:26px;text-align:right;overflow:hidden;color:#777}div.line-container ul li .line-content[data-v-0553077e]{font-size:18px;line-height:26px;margin:0 20px 0 55px;padding:0;display:inline-block;word-wrap:break-word;white-space:pre-wrap;word-break:normal;border:none;border-radius:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0553077e","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/lineNumber.vue
// module id = 353
// module chunks = 0